import React from 'react';
import RSelect, {Props} from 'react-select';


export type SelectProps = Props & {
    variant?: "default" | "modalish";
    fullWidth?: boolean;
};

export const Select: React.FC<Props> = ({
    variant = "default",
    fullWidth,
    ...rest
}) => {

    return <RSelect {...rest} styles={{
        container: (provided, state) => {
            if (fullWidth) {
                provided.width = "100%";
            }
            return provided;
        },
        control: (provided, state) => {

            if(variant==="modalish"){
                return {
                    ...provided,
                    borderRadius: "4px",
                    borderColor: "#a9a9a9",
                    boxShadow: "none",
                    outline: "none",
                    "&:hover": {
                        borderColor: "#a9a9a9",
                    }
                }
            }
                return {
                    ...provided,
                    borderRadius: 12,
                    borderColor: "#449DF7",
                    padding: 4,
                    paddingLeft: 16,
                    paddingRight: 8,
                    "&:hover": {
                        borderColor: "#449DF7",
                    }
                }

        },
        indicatorSeparator: (provided, state) => {
            return {};
        },
        indicatorsContainer: (provided, state) => {
            if(variant==="modalish") {
                return {
                    ...provided,
                    "& svg": {
                        fill: " #a9a9a9",
                    },
                }
            }
            return {
                ...provided,
                "& svg": {
                    fill: " #449DF7",
                },
            };
        },
        singleValue: (provided, state) => {
            if(variant==="modalish") {
                    return {
                        ...provided,
                        color: "#000000",
                    }
            }
            return {
                ...provided,
                color: "#449DF7",
            }
        },
        option: (provided, state) => {
            return {
                ...provided,
                ...(
                    state.isSelected ? {backgroundColor: "#449DF7"} : {}
                )
            };
        },
    }}/>;
};